;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { EMPLOYEE_STATUS } from '@workspace/ui/lib';
import type { JwtPayload } from '@workspace/ui/types';
import { getEmployeeByUserAndOrganisation } from '@/actions/employees';
import { getEligiblePaydayCountries } from '@/actions/salary-rewards';
import { getActiveOrganisationFromToken } from '@/lib/active-organisation';
import { isEmployeeServer } from '@/lib/helpers';

export function isEmployeeSalaryWalletEligible(params: {
  employee?: { status?: string; country_id?: number } | null;
  eligibleCountryIds: string[];
}): boolean {
  const { employee, eligibleCountryIds } = params;
  if (!employee || employee.status !== EMPLOYEE_STATUS.EMPLOYED) return false;
  return eligibleCountryIds.includes(String(employee.country_id));
}

/**
 * Salary wallet is only available to employed employees whose employment country is in the
 * billing service's eligible payday countries list ({@link getEligiblePaydayCountries}).
 */
export async function canAccessSalaryWallet(decodedToken: JwtPayload | null): Promise<boolean> {
  if (!decodedToken) return false;

  // Cheap JWT-only check first, avoids the employee/eligible-countries API calls for non-employees.
  const isEmployee = await isEmployeeServer();
  if (!isEmployee) return false;

  const organisationId = getActiveOrganisationFromToken(decodedToken)?.id;
  const userId = decodedToken.user?.id;
  if (!organisationId || !userId) return false;

  try {
    const [employeeResponse, eligibleCountriesResponse] = await Promise.all([
      getEmployeeByUserAndOrganisation(userId, organisationId),
      getEligiblePaydayCountries(),
    ]);

    const eligibleCountryIds = (eligibleCountriesResponse.data ?? []).map((country) =>
      String(country.country_id)
    );

    return isEmployeeSalaryWalletEligible({
      employee: employeeResponse?.data,
      eligibleCountryIds,
    });
  } catch {
    return false;
  }
}
